import React, { useEffect, useState } from 'react'

export default function EntryItemAllCheckbox({items, handleSelectAll}) {

  const [allSelected, setAllSelected] = useState(false)

  useEffect(() => {
    const allCount = items.length;

    const selectedCount = items.filter(item => item.selected).length;
    const editableCount = items.filter(item => item.editable).length;

    if (allCount > 0 && selectedCount > 0 && selectedCount === editableCount) {
      setAllSelected(true)
    } else {
      setAllSelected(false)
    }
  }, [items])

  return (
    <div className="check_blog">
      <input
        type="checkbox" id="inpAllCheck"
        className="inp_check" checked={allSelected}
        onChange={handleSelectAll}
      />
      <label htmlFor="inpAllCheck" className="ico_blog ico_checkbox">
        선택 됨
      </label>
    </div>
  )
}
